import { Component, Inject, LOCALE_ID } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogActions } from 'src/app/model/dictionary';

export class SimpleSelectDialogData<TObject extends {id: number, name: string}> {
  title = '';
  description?: string | undefined;
  dropdownLabel?: string | undefined;
  allItems: TObject[] = [];
}

export class SimpleSelectDialogResult<TObject extends {id: number, name: string}> {
  event!: DialogActions;
  selectedItem: TObject | undefined;
}

@Component({
  selector: 'app-simple-select-dialog',
  templateUrl: './simple-select-dialog.component.html',
  styleUrls: ['./simple-select-dialog.component.scss']
})
export class SimpleSelectDialogComponent<TObject extends {id: number, name: string}> {

  dialogTitle: string;
  dialogDescription: string | undefined;
  dropdownLabel: string;

  allItems: TObject[] = [];

  selectedItem: TObject | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: SimpleSelectDialogData<TObject>,
    @Inject(LOCALE_ID) public locale: string,
    private dialogRef: MatDialogRef<SimpleSelectDialogComponent<TObject>>
  ) {
    this.dialogTitle = data.title;
    this.dialogDescription = data.description;
    this.dropdownLabel = data.dropdownLabel ?? "";
    this.allItems = data.allItems
    this.allItems =
      this.allItems.sort((a, b) => a.name.toLocaleLowerCase(this.locale).localeCompare(b.name.toLocaleLowerCase(this.locale)));
  }

  closeDialog() {
    this.dialogRef.close({
      event: DialogActions.REJECT
    });
  }

  onSuccess() {
    if (!this.selectedItem) {
      return;
    }

    this.dialogRef.close({
      event: DialogActions.CONFIRM,
      selectedItem: this.selectedItem
    });
  }

  displayFn(x: TObject) {
    return x.name;
  }
}
